import { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import { AppBar, Avatar, Box, Container, Toolbar, Typography } from '@mui/material';

import theme from './theme';
import dataSR from './data/sr.json';
import dataEN from './data/en.json';

import Menu from './components/Menu';
import Cards from './components/Cards';

const styles = {
  header: {
    background: '#e5e5e5',
    boxShadow: 'none',
    height: '64px',
  },
  headerToolbar: {
    textAlign: { sm: 'left', xs: 'center' },
    display: { sm: 'flex', xs: 'block' },
    boxSizing: 'border-box',
    paddingTop: { sm: 0, xs: '12px' },
  },
  headerAvatar: {
    marginRight: '5px',
    width: '36px',
    height: '36px',
    display: { sm: 'flex', xs: 'inline-block' },
  },
  headerTitle: {
    display: { sm: 'flex', xs: 'inline-block' },
    flexGrow: { sm: 1, xs: 0 },
    textTransform: 'uppercase',
    fontWeight: '600',
  },
  headerLastName: {
    marginLeft: '12px',
  },
  headerFirstName: {
    marginLeft: '6px',
    fontWeight: '400',
  },
  containerMain: {
    paddingLeft: { sm: '16px', xs: 0 },
    paddingRight: { sm: '16px', xs: '10px' },
  },
  cardsTitle: {
    fontSize: '24px',
    margin: '24px 18px 0',
    opacity: 0.3,
    color: '#555',
    textTransform: 'uppercase',
  },
};

const words = {
  sr: {
    work: 'Radno iskustvo',
    projects: 'Projekti',
    education: 'Obrazovanje',
  },
  en: {
    work: 'Work',
    projects: 'Projects',
    education: 'Education',
  },
}

const App = () => {
  const defaultLang = localStorage.lang || 'sr';
  const [lang, setLang] = useState(defaultLang);

  const data = lang === 'en' ? dataEN : dataSR;
  const { work, projects, education } = data;

  const handleLangChange = (newLang) => {
    localStorage.lang = newLang;
    setLang(newLang);
  };

  const name = `${data.name.last} ${data.name.first}`;
  const langWords = words[lang];

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="fixed" sx={styles.header}>
        <Container maxWidth="xl">
          <Toolbar sx={styles.headerToolbar} disableGutters>
            <Avatar
              src={data.photo}
              size="small"
              alt={name}
              sx={styles.headerAvatar}
            />
            <Typography
              variant="h6"
              color="primary"
              sx={styles.headerTitle}
              noWrap
            >
              <Box component="span" sx={styles.headerLastName}>
                {data.name.last}
              </Box>
              <Box component="span" sx={styles.headerFirstName}>
                {data.name.first}
              </Box>
            </Typography>
            <Menu lang={lang} setLang={handleLangChange} />
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="xl" sx={styles.containerMain}>
        <Typography variant="h4" sx={styles.cardsTitle}>
          {langWords.work}
        </Typography>
        <Cards data={work} name="company" sub="position" icons="tech" />

        <Typography variant="h4" sx={styles.cardsTitle}>
          {langWords.projects}
        </Typography>
        <Cards data={projects} sub="blurb" />

        <Typography variant="h4" sx={styles.cardsTitle}>
          {langWords.education}
        </Typography>
        <Cards data={education} sub="course" flipper={false} />
      </Container>
    </ThemeProvider>
  );
}

export default App;
